import "@/App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import HomePage from "./pages/HomePage";
import AdminPage from "./pages/AdminPage";
import ShopPage from "./pages/ShopPage";
import GoldSeaMossGelPage from "./pages/products/GoldSeaMossGelPage";
import PurpleSeaMossGelPage from "./pages/products/PurpleSeaMossGelPage";
import CustomSeaMossBlendPage from "./pages/products/CustomSeaMossBlendPage";
import LearnHubPage from "./pages/learn/LearnHubPage";
import WhatIsSeaMossPage from "./pages/learn/WhatIsSeaMossPage";
import GoldVsPurpleSeaMossPage from "./pages/learn/GoldVsPurpleSeaMossPage";
import HowToUseSeaMossGelPage from "./pages/learn/HowToUseSeaMossGelPage";
import HowToStoreSeaMossGelPage from "./pages/learn/HowToStoreSeaMossGelPage";
import SeaMossActiveRoutinesPage from "./pages/learn/SeaMossActiveRoutinesPage";
import SeaMossWeightManagementPage from "./pages/learn/SeaMossWeightManagementPage";
import SeaMossBenefitsPage from "./pages/learn/SeaMossBenefitsPage";
import SeaMossResearchPage from "./pages/learn/SeaMossResearchPage";
import SeaMossNutritionPage from "./pages/learn/SeaMossNutritionPage";
import AboutPage from "./pages/AboutPage";
import ReviewsPage from "./pages/ReviewsPage";
import FaqPage from "./pages/FaqPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import IngredientsIndexPage from "./pages/ingredients/IngredientsIndexPage";
import IngredientDetailPage from "./pages/ingredients/IngredientDetailPage";
import BlendsIndexPage from "./pages/blends/BlendsIndexPage";
import BlendDetailPage from "./pages/blends/BlendDetailPage";
import ComingSoonSkinRangePage from "./pages/coming-soon/ComingSoonSkinRangePage";
import ComingSoonHerbalPantryPage from "./pages/coming-soon/ComingSoonHerbalPantryPage";
import StoriesPage from "./pages/StoriesPage";
import CommunityRewardPage from "./pages/CommunityRewardPage";
import MixInsPage from "./pages/MixInsPage";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/shop" element={<ShopPage />} />
              <Route path="/products/gold-sea-moss-gel" element={<GoldSeaMossGelPage />} />
              <Route path="/products/purple-sea-moss-gel" element={<PurpleSeaMossGelPage />} />
              <Route path="/products/custom-sea-moss-blend" element={<CustomSeaMossBlendPage />} />
              <Route path="/ingredients" element={<IngredientsIndexPage />} />
              <Route path="/ingredients/:slug" element={<IngredientDetailPage />} />
              <Route path="/mix-ins" element={<MixInsPage />} />
              <Route path="/mixins" element={<Navigate to="/mix-ins" replace />} />
              <Route path="/blends" element={<BlendsIndexPage />} />
              <Route path="/blends/:slug" element={<BlendDetailPage />} />
              <Route path="/coming-soon/skin-range" element={<ComingSoonSkinRangePage />} />
              <Route path="/coming-soon/herbal-pantry" element={<ComingSoonHerbalPantryPage />} />
              <Route path="/skin-care" element={<Navigate to="/coming-soon/skin-range" replace />} />
              <Route path="/stories" element={<StoriesPage />} />
              <Route path="/herbs" element={<Navigate to="/ingredients" replace />} />
              <Route path="/how-to-use" element={<Navigate to="/learn/how-to-use-sea-moss-gel" replace />} />
              <Route path="/gold-vs-purple" element={<Navigate to="/learn/gold-vs-purple-sea-moss" replace />} />
              <Route path="/learn" element={<LearnHubPage />} />
              <Route path="/learn/what-is-sea-moss" element={<WhatIsSeaMossPage />} />
              <Route path="/learn/gold-vs-purple-sea-moss" element={<GoldVsPurpleSeaMossPage />} />
              <Route path="/learn/how-to-use-sea-moss-gel" element={<HowToUseSeaMossGelPage />} />
              <Route path="/learn/how-to-store-sea-moss-gel" element={<HowToStoreSeaMossGelPage />} />
              <Route path="/learn/sea-moss-for-active-routines" element={<SeaMossActiveRoutinesPage />} />
              <Route path="/learn/sea-moss-for-weight-management" element={<SeaMossWeightManagementPage />} />
              <Route path="/learn/sea-moss-benefits" element={<SeaMossBenefitsPage />} />
              <Route path="/learn/sea-moss-research" element={<SeaMossResearchPage />} />
              <Route path="/learn/sea-moss-nutrition" element={<SeaMossNutritionPage />} />
              <Route path="/learn/resources" element={<Navigate to="/learn/sea-moss-nutrition" replace />} />
              <Route path="/learn/92-trace-minerals" element={<Navigate to="/learn/sea-moss-nutrition#trace-minerals" replace />} />
              <Route path="/learn/amino-acids" element={<Navigate to="/learn/sea-moss-nutrition#amino-acids" replace />} />
              <Route path="/research" element={<Navigate to="/learn/sea-moss-research" replace />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/community-reward" element={<CommunityRewardPage />} />
              <Route path="/privacy-policy" element={<PrivacyPage />} />
              <Route path="/privacy" element={<Navigate to="/privacy-policy" replace />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster
            position="bottom-right"
            closeButton
            expand={false}
            visibleToasts={2}
            gap={10}
            toastOptions={{
              classNames: {
                toast: "moss-sonner-toast",
                title: "moss-sonner-title",
                description: "moss-sonner-description",
                closeButton: "moss-sonner-close",
              },
            }}
          />
        </CartProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
